import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHealthiconsMoneyBag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M18.03 4.5c-3.389 0-6.475 1.119-8.301 2.033q-.247.124-.462.242a10 10 0 0 0-.717.425l2.077 3.058.978.39c3.823 1.928 8.948 1.928 12.77 0l1.11-.576L27.45 7.2q-.611-.397-1.267-.718C24.366 5.578 21.353 4.5 18.03 4.5m-4.832 3.462a19 19 0 0 1-2.175-.546c1.71-.76 4.26-1.566 7.007-1.566 1.903 0 3.702.387 5.19.878-1.744.245-3.604.661-5.377 1.173-1.395.404-3.026.36-4.645.061m11.97 3.798-.184.093c-4.205 2.121-9.782 2.121-13.986 0l-.175-.088c-6.317 6.93-11.14 19.733 7.206 19.733s13.407-13.04 7.14-19.738M17.25 18a1.5 1.5 0 1 0 0 3zm1.5-1.5v-.75h-1.5v.75a3 3 0 0 0 0 6v3a1.5 1.5 0 0 1-1.415-1 .751.751 0 1 0-1.414.5 3 3 0 0 0 2.829 2v.75h1.5V27a3 3 0 0 0 0-6v-3c.652 0 1.208.416 1.415 1a.75.75 0 1 0 1.414-.5 3 3 0 0 0-2.829-2m0 6v3a1.5 1.5 0 1 0 0-3",
		clipRule: "evenodd"
	})
});
export default SvgHealthiconsMoneyBag;
